
import '../css/myLogs.css'
import React, { useState, useEffect, useCallback } from 'react';
import Encounter from './commonHooks.encounter';


const LogsViewer = (dat) => {
    const [data, setData] = useState(null);
    const [filteredData, setFilteredData] = useState(null);
    const [nameFilter, setNameFilter] = useState("");
    const [classFilter, setClassFilter] = useState("");
    const [bossFilter, setBossFilter] = useState("");
    const [timeFilter, setTimeFilter] = useState(0);
    const [dpsFilter, setDpsFilter] = useState(false);

    useEffect(() => {
        setData(dat.dat);
        setFilteredData(dat.dat);
    }, [dat]);
    
    const getLocalPlayerDps = useCallback((encounter) => {
        const entitiesForEncounter = data.entity.filter(z => z.fight_start === encounter.fight_start);
        const localPlayerEntity = entitiesForEncounter.find(z => z.name === encounter.local_player);
        if (localPlayerEntity == null) {
            return null;
        }
        return localPlayerEntity.dps;
    }, [data]);

    const checkForName = useCallback((encounter, name) => {
        const entitiesForEncounter = data.entity.filter(z => z.fight_start === encounter.fight_start);
        const localPlayerEntity = entitiesForEncounter.find(z => z.name.toLowerCase().includes(name));
        if (localPlayerEntity == null) {
            return false;
        }
        return true;
    }, [data]);

    const checkForClass = useCallback((encounter, clas) => {
        const entitiesForEncounter = data.entity.filter(z => z.fight_start === encounter.fight_start);
        const localPlayerEntity = entitiesForEncounter.find(z => z.class.toLowerCase().includes(clas))
        if (localPlayerEntity == null) {
            return false;
        }
        return true;
    }, [data]);

    const compareDps = useCallback((a, b) => {
        const aDps = getLocalPlayerDps(a);
        const bDps = getLocalPlayerDps(b);

        if (aDps != null && bDps != null) {
            return bDps - aDps;
        } else if (aDps != null) {
            return -1;
        } else if (bDps != null) {
            return 1;
        } else {
            return 0;
        }
    }, [getLocalPlayerDps]);

    const filterArrayByString = useCallback((arr, str) => {
        const lowerCaseStr = str.toLowerCase();
        return arr.filter(element => checkForName(element, lowerCaseStr));
    }, [checkForName]);

    const filterArrayByBoss = useCallback((arr, str) => {
        const lowerCaseStr = str.toLowerCase();
        return arr.filter(element => element.current_boss.toLowerCase().includes(lowerCaseStr));
    }, []);

    const filterArrayByTime = useCallback((arr, int) => {
        return arr.filter(element => (element.duration / 1000) > int);
    }, []);

    const filterArrayByClass = useCallback((arr, str) => {
        const lowerCaseStr = str.toLowerCase();
        return arr.filter(element => checkForClass(element, lowerCaseStr));
    }, [checkForClass])

    const filtering = useCallback(() => {
        if (!data) return;

        let newEncounter = [...data.encounter];
        if (dpsFilter) {
            newEncounter.sort(compareDps);
        }
        if (nameFilter) {
            newEncounter = filterArrayByString(newEncounter, nameFilter);
        }
        if (bossFilter) {
            newEncounter = filterArrayByBoss(newEncounter, bossFilter);
        }
        if (timeFilter > 0) {
            newEncounter = filterArrayByTime(newEncounter, timeFilter);
        }
        if (classFilter) {
            newEncounter = filterArrayByClass(newEncounter, classFilter);
        }

        const newData = {
            entity: [...data.entity],
            encounter: newEncounter,
        };

        setFilteredData(newData);
    }, [data, classFilter, dpsFilter, nameFilter, bossFilter, timeFilter, compareDps,filterArrayByClass, filterArrayByString, filterArrayByBoss, filterArrayByTime]);

    useEffect(() => {
        filtering();
    }, [nameFilter, bossFilter, timeFilter, dpsFilter, filtering]);


    return (
        <div className="logs-container">
                <div className="filter-container">
                    {/* Filter elements */}
                    <div className="input-filter">
                        <label>Filter by player name:</label>
                        <input
                            type="text"
                            placeholder="e.g Yandoh, Legalia"
                            value={nameFilter}
                            onChange={(e) => setNameFilter(e.target.value)}
                        />
                    </div>
                    <div className="input-filter">
                        <label>Filter by boss:</label>
                        <input
                            type="text"
                            placeholder="e.g Gargadeth, Thaemine"
                            value={bossFilter}
                            onChange={(e) => setBossFilter(e.target.value)}
                        />
                    </div>
                    <div className="input-filter">
                        <label>Filter by class:</label>
                        <input
                            type="text"
                            placeholder="e.g Deathblade, Gunslinger"
                            value={classFilter}
                            onChange={(e) => setClassFilter(e.target.value)}
                        />
                    </div>
                    <div className="input-filter">
                        <label>Min duration:</label>
                        <input
                            type="text"
                            pattern="[0-9]*"    
                            placeholder='Seconds'
                            min="0"
                            step={30}
                            value={isNaN(timeFilter) ? '' : timeFilter}
                            onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, '');
                                setTimeFilter(value);
                            }}
                        />
                    </div>
                    <button
                        className={dpsFilter ? "active" : ""}
                        onClick={() => setDpsFilter(!dpsFilter)}
                    >
                        Toggle DPS Filter
                    </button>
                </div>
                <div className="table-container">
                    <table className="myLogs-table">
                        {/* Table content */}
                        <thead>
                            <tr>
                                <th>Encounter</th>
                                <th>Local User</th>
                                <th>My DPS</th>
                                <th>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData && filteredData.encounter && filteredData.encounter.map((encounter, index) => {
                                const entitiesForEncounter = filteredData.entity.filter(entity => entity.fight_start === encounter.fight_start);
                                return (
                                    <Encounter
                                        key={index}
                                        local_user={encounter.local_player}
                                        encounter={encounter.current_boss}
                                        clear={encounter.cleared}
                                        date={encounter.fight_start}
                                        difficulty={encounter.difficulty}
                                        entities_array={entitiesForEncounter}
                                        party_info={JSON.parse(encounter.party_info)}
                                    />
                                );
                            })}
                        </tbody>
                    </table>
                </div>
                <h5>Refresh the page on first upload if logs are not showing.</h5>
            </div>
    )
}

export default LogsViewer